import * as React from 'react';
import { Modal, Row, Input } from 'antd';
import Form, { FormItem } from '../../../components/Form';
import { IUpdateNonProductOrderItem } from 'data-layer/src/services/OrderItems/interfaces/IUpdateOrderItem';

interface IUpdateNonProductOrderItemEditorProps {
  item: GQL.IOrderItem;
  order: GQL.IOrder;
  onUpdate: (data: IUpdateNonProductOrderItem) => void;
  onCancel: () => void;
}

interface IUpdateNonProductOrderItemEditorState {
  data: {
    title: string | undefined;
    name: any;
    recommendedPrice?: number | null;
    price: number;
    sku: string;
    quantity: number;
  }
}

export default class UpdateNonProductOrderItemEditor extends React.Component<IUpdateNonProductOrderItemEditorProps, IUpdateNonProductOrderItemEditorState> {

  private form;

  constructor(props: IUpdateNonProductOrderItemEditorProps) {
    super(props);

    this.state = {
      data: {
        title: props.item.title,
        name: props.item.name,
        recommendedPrice: props.item.recommendedPrice,
        price: props.item.price,
        sku: props.item.sku,
        quantity: props.item.quantity
      }
    };

    this.form = React.createRef;

    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  public render() {
    const { item, order } = this.props;

    const languageCode = order.language;

    return (
      <Modal
        title={`${!item ? 'New' : 'Update'} order item`}
        visible={true}
        maskClosable={false}
        cancelText={'Cancel'}
        okText={'Update'}
        onOk={this.onSubmit}
        onCancel={() => this.props.onCancel()}
      >
        <Row>
          <Form
            ref={f => this.form = f}
            displayFooter={false}
            onSubmit={this.onSubmit}
            onCancel={() => this.props.onCancel()}
          >
            <FormItem label={'Title'} required={true}>
              <Input
                name={'title'}
                placeholder="Title"
                value={this.state.data.title}
                required={true}
                autoFocus={true}
                onChange={this.onChange}
              />
            </FormItem>
            <FormItem label={'Name'} required={true}>
              <Input
                name={'name'}
                placeholder="Name"
                addonBefore={languageCode}
                value={this.state.data.name[languageCode] || undefined}
                required={true}
                onChange={(e: any) => this.onChange(e, e.target.value, languageCode)}
              />
            </FormItem>
            <FormItem label={'Item number'}>
              <Input
                name={'sku'}
                placeholder="Code"
                value={this.state.data.sku}
                onChange={this.onChange}
              />
            </FormItem>
            <FormItem label={'Recommended price'}>
              <Input
                name={'recommendedPrice'}
                placeholder="Recommended price"
                addonAfter={order.currency ? order.currency.value : undefined}
                value={this.state.data.recommendedPrice || undefined}
                type={'number'}
                step={'0.01'}
                onChange={(e: any) => this.onChange(e, parseFloat(e.target.value))}
              />
            </FormItem>
            <FormItem label={'Item price (incl. Vat)'} required={true}>
              <Input
                type={'number'}
                name={'price'}
                step={'0.01'}
                placeholder="Price"
                addonAfter={order.currency ? order.currency.value : undefined}
                value={this.state.data.price}
                required={true}
                onChange={e => this.onChange(e, parseFloat(e.target.value))}
              />
            </FormItem>
            <FormItem label={'Quantity'} required={true}>
              <Input
                type={'number'}
                name={'quantity'}
                placeholder="Quantity"
                value={this.state.data.quantity}
                required={true}
                onChange={e => this.onChange(e, parseInt(e.target.value))}
              />
            </FormItem>
          </Form>
        </Row>
      </Modal>
    );
  }

  private onChange(e: any, val: any = null, language?: string) {
    const { name, value, checked } = e.target;

    const inputValue = val ? val : (value !== undefined ? value : checked);

    const newValue = (language
      ? { [name]: { ...this.state.data[name], [language]: inputValue } }
      : { [name]: inputValue });

    this.setState({
      data: {...this.state.data, ...newValue},
    });
  }

  private async onSubmit() {
    if (this.form) {
      if (this.form.validate()) {
        this.props.onUpdate({...this.state.data} as IUpdateNonProductOrderItem);
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/scenes/OrderItems/OrderItemsEditors/UpdateNonProductOrderItemEditor.tsx